/**
 * Tour steps for the Timeline page.
 */
const timelineSteps = [
  {
    target: '[data-tour="timeline-view"]',
    title: 'Your health journey 🗓️',
    content:
      'Every report, milestone, and AI insight appears here in chronological order — a living record of your health story.',
    placement: 'top',
    route: '/timeline',
    tourName: 'timeline',
    navigateOnNext: '/insights',
  },
];

export default timelineSteps;
